import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const TuneIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M14.65,20H5.35C2.4,20,0,17.6,0,14.65V5.35C0,2.4,2.4,0,5.35,0h9.3c2.95,0,5.35,2.4,5.35,5.35v9.3c0,2.95-2.4,5.35-5.35,5.35ZM5.35,1.4c-2.18,0-3.95,1.77-3.95,3.95v9.3c0,2.18,1.77,3.95,3.95,3.95h9.3c2.18,0,3.95-1.77,3.95-3.95V5.35c0-2.18-1.77-3.95-3.95-3.95H5.35Z" />
  <path d="M15.78,10.7H7.04c-.39,0-.7-.31-.7-.7s.31-.7.7-.7h8.75c.39,0,.7.31.7.7s-.31.7-.7.7Z" />
  <path d="M5.63,12.11c-1.16,0-2.11-.95-2.11-2.11s.95-2.11,2.11-2.11,2.11.95,2.11,2.11c0,1.16-.95,2.11-2.11,2.11h0ZM5.63,9.29c-.39,0-.71.32-.71.71s.32.71.71.71.71-.32.71-.71c0-.39-.32-.71-.71-.71h0Z" />
  <path d="M12.96,6.05H4.22c-.39,0-.7-.31-.7-.7s.31-.7.7-.7h8.75c.39,0,.7.31.7.7s-.31.7-.7.7Z" />
  <path d="M12.96,15.35H4.22c-.39,0-.7-.31-.7-.7s.31-.7.7-.7h8.75c.39,0,.7.31.7.7s-.31.7-.7.7Z" />
  <path d="M14.37,7.46c-1.16,0-2.11-.95-2.11-2.11s.95-2.11,2.11-2.11,2.11.95,2.11,2.11-.95,2.11-2.11,2.11ZM14.37,4.64c-.39,0-.71.32-.71.71s.32.71.71.71.71-.32.71-.71-.32-.71-.71-.71Z" />
  <path d="M14.37,16.76c-1.16,0-2.11-.95-2.11-2.11s.95-2.11,2.11-2.11,2.11.95,2.11,2.11-.95,2.11-2.11,2.11ZM14.37,13.94c-.39,0-.71.32-.71.71s.32.71.71.71.71-.32.71-.71-.32-.71-.71-.71Z" />
 </svg>,
 "Tune"
);
